import { Box, DatePicker } from '@customerio/pluma-components/react';
import { parseDate } from '@internationalized/date';
import type { CalendarDate } from '@internationalized/date';

interface DateFilterProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder: string;
  timeOfDay: 'start' | 'end'; // 'start' for 00:00:00, 'end' for 23:59:59
}

export function DateFilter({ value, onChange, label, placeholder, timeOfDay }: DateFilterProps) {
  const currentDate: CalendarDate | null =
    value !== ''
      ? (() => {
          try {
            const dateStr = value.split('T')[0];
            return parseDate(dateStr);
          } catch {
            return null;
          }
        })()
      : null;

  const timeString = timeOfDay === 'start' ? 'T00:00:00Z' : 'T23:59:59Z';

  return (
    <Box p="300">
      <DatePicker
        label={label}
        value={currentDate}
        onChange={(date) => {
          if (date != null) {
            onChange(`${date.toString()}${timeString}`);
          }
        }}
        onClear={() => onChange('')}
        placeholder={placeholder}
        isClearable={true}
        aria-label={`Filter by ${label.toLowerCase()}`}
      />
    </Box>
  );
}
